import gsap, { Power0 } from "gsap";
import React, { FormEvent, KeyboardEvent, UIEvent } from "react";
import { Controller } from "./core/Controller";
import { EVENTS } from "./core/EVENTS";
import CheckFairness from "./windows/CheckFairness";
import Gifs from "./windows/Gifs";
import Emojies from "./windows/Emojies";

import "./Chat.css";
import Common from "./Common";
import { Comm } from "./core/comm/Comm";

let id = 1000;

export default class Chat extends React.Component<Chat.Props, Chat.State>
{

    messageBuffer: Record<string, Array<string>> = {};


    ref: React.RefObject<HTMLDivElement>;
    refSpam: React.RefObject<HTMLDivElement>;
    refInput: React.RefObject<HTMLTextAreaElement>;

    spamTween: GSAPTween;

    inputFocused: boolean;

    
    constructor(props: Chat.Props)
    {
        super(props);

        this.state = {
            input: "",
            playersOnline: 1,
            spam: false,
            counter: 160,
            messages: [],
            scroll: true,
            newMessage: false,

            window: null,
            windowInput: ""
        };

        this.refInput = React.createRef();
        this.ref = React.createRef();
        this.refSpam = React.createRef();

        this.onWindowDown = this.onWindowDown.bind(this);
        this.onResize = this.onResize.bind(this);

        // TODO: gif...
        // TODO: rain???...
    }

    onResize()
    {
        // mainly for mobile view - so it automatically scrolls to top when changing perspective on phone
        // uncomment this when spribe decides to fix this on their client
        // this.scrollToTop();
    }


    checkFairness(id: string)
    {
        app.addWindow(<CheckFairness
            roundId={id}
        />);
    }


    clickLike(data: Comm.ResponseTypes.Chat)
    {
        if (data.liked)
        {
            data.liked = false;
            data.likes--;
        }
        else
        {
            data.liked = true;
            data.likes++;
        }

        this.setState({
            messages: this.state.messages
        });
    }


    addToChat(message: string)
    {
        if (this.refInput.current.value.length + message.length <= 160)
        {
            this.refInput.current.value += message;
            this.setState({
                input: this.refInput.current.value,
                counter: 160 - this.refInput.current.value.length
            });
        }
    }


    componentDidMount()
    {
        this.inputFocused = false;

        Comm.on(Comm.RESPONSE.CHAT, this.onChatSocketMessage, this);
        Comm.on(Comm.RESPONSE.GAME_INFO, this.onRefresh, this);

        EVENTS.on(EVENTS.GAME.PLAYERS_COUNT, this.onPlayersCount, this);

        window.addEventListener("resize", this.onResize);

        this.scrollToTop();

        window.addEventListener("pointerdown", this.onWindowDown);
    }


    componentWillUnmount()
    {
        Comm.off(Comm.RESPONSE.CHAT, this.onChatSocketMessage, this);
        Comm.off(Comm.RESPONSE.GAME_INFO, this.onRefresh, this);

        EVENTS.off(EVENTS.GAME.PLAYERS_COUNT, this.onPlayersCount, this);

        window.removeEventListener("resize", this.onResize);

        window.removeEventListener("pointerdown", this.onWindowDown);
    }


    componentDidUpdate(prevProps: Readonly<Chat.Props>, prevState: Readonly<Chat.State>, snapshot?: any)
    {
        if (prevState.spam && !this.state.spam && this.inputFocused)
        {
            this.refInput.current.focus();
        }

        this.scrollToTop();

        if (this.refSpam.current && !this.spamTween)
        {
            const obj = { x: 0 }
            this.spamTween = gsap.to(obj, {
                duration: 5,
                ease: Power0.easeNone,
                x: -100,
                onUpdate: () =>
                {
                    this.refSpam.current.style.transform = "translateX(" + obj.x + "%)";
                },
                onComplete: () =>
                {
                    this.spamTween = null;
                    this.setState({
                        spam: false
                    });
                }
            });
        }
    }


    onChatSocketMessage(data: Comm.ResponseTypes.Chat, skipStateUpdate: boolean = false)
    {
        try
        {
            if (data.type == "server")
            {
                let message = data.message as Comm.ResponseTypes.BetData & { message: string };
                if (typeof message == "string")
                {
                    message = JSON.parse(message);
                }

                data.type = "bot";
                // @ts-ignore
                data.player_id = "bot";
                data.data = {
                    player_id: message.player_id,
                    username: message.username,
                    multiplier: message.multiplier,
                    win_amount: message.win_amount,
                    crashpoint: message.crashpoint,
                    bet_amount: message.bet_amount,
                    currency: currency,
                    game_round_id: message.game_round_id,
                    timestamp: message.timestamp,
                    bet_id: 0,
                    player_avatar: Controller.getAvatarForUser(message.player_id.toString())
                };

                // @ts-ignore
                const langChat = window.lang.game["chat-widget"]["chat-message"] as Record<string, string>;

                data.sender = "captain"
                data.message = langChat[message.message] || message.message;

                data.id = id++;

                this.state.messages.push(data);

                if (!skipStateUpdate)
                {
                    this.setState({
                        messages: this.state.messages,
                        newMessage: !this.state.scroll
                    });
                }
                return;
            }


            // handling multiple messages
            const message = data.message as string;

            const index = Number(message.substring(0, 1)) - 1;
            const count = Number(message.substring(1, 2));
            const packet = message.substring(2);

            if (!this.messageBuffer[data.player_id])
            {
                this.messageBuffer[data.player_id] = new Array(count).fill(null);
            }

            this.messageBuffer[data.player_id][index] = packet;

            const pending = this.messageBuffer[data.player_id].some(s => !s);

            // wait for all messages to arrive
            if (pending)
            {
                return;
            }


            // combine them
            data.message = "";

            this.messageBuffer[data.player_id].forEach(packet =>
            {
                data.message += packet;
            });

            delete this.messageBuffer[data.player_id];

            // setting avatar
            const avatar = (data.message[0].charCodeAt(0) - 0xE003 + 1).toString();
            data.avatar = avatar;
            data.message = data.message.substring(1);

            if (Controller.getAvatarForUser(data.player_id.toString()) != avatar)
            {
                Controller.setAvatarForUser(data.player_id.toString(), avatar);
            }

            // check if player sent bet data...
            const regex = /\uE000(.*?)\uE001(.*?)\uE001(.*?)\uE001(.*?)\uE001(.*?)\uE001(.*?)\uE001(.*?)\uE001(.*?)\uE001(.*?)\uE001(.*?)$/g
            const match = regex.exec(data.message);

            if (data.type == "server")
            {
                data.type = "bot";

            }
            else if (match)
            {
                data.type = "share";

                data.data = {
                    player_id: Number(match[1]),
                    username: match[2],
                    multiplier: match[3],
                    win_amount: match[4],
                    crashpoint: match[5],
                    bet_amount: match[6],
                    currency: match[7],
                    game_round_id: Number(match[8]),
                    timestamp: match[9],
                    bet_id: 0,
                    player_avatar: Controller.getAvatarForUser(match[1])
                };

                data.message = match[10];
            }
            else if (data.message.charAt(0) == String.fromCharCode(0xE002))
            {
                data.type = "gif"
                data.message = data.message.substring(1);
            }
            else
            {
                data.type = "player";
            }

            data.id = id++;

            this.state.messages.push(data);

            if (!skipStateUpdate)
            {
                this.setState({
                    messages: this.state.messages,
                    newMessage: !this.state.scroll
                });
            }
        }
        catch (e)
        {
            console.error("message error:", e);
            data.id = id++;
            this.state.messages.push(data);

            if (!skipStateUpdate)
            {
                this.setState({
                    messages: this.state.messages,
                    newMessage: !this.state.scroll
                });
            }
        }
    }


    onRefresh(data: Comm.ResponseTypes.GameInfo)
    {
        const messages = data.result.chat.history.slice();

        messages.forEach(message =>
        {
            this.onChatSocketMessage(message, true);
        });

        this.setState({
            messages: this.state.messages
        });
    }


    onPlayersCount(count: number)
    {
        this.setState({
            playersOnline: count
        });
    }


    onScroll(event: UIEvent<HTMLDivElement>)
    {
        const scroll = this.ref.current.scrollTop >= (this.ref.current.scrollHeight - this.ref.current.clientHeight);
        if (scroll !== this.state.scroll)
        {
            this.setState({
                scroll: scroll,
                newMessage: this.state.newMessage && !scroll
            });
        }
    }


    scrollToTop()
    {
        if (this.ref.current && this.state.scroll && this.ref.current.scrollTop !== (this.ref.current.scrollHeight - this.ref.current.clientHeight))
        {
            this.ref.current.scrollTop = this.ref.current.scrollHeight - this.ref.current.clientHeight;
        }
    }


    onKeyDown(e: KeyboardEvent<HTMLTextAreaElement>)
    {
        if (e.key == "Enter")
        {
            e.preventDefault();
            e.stopPropagation();

            this.send();
        }
    }


    onInput(e: FormEvent<HTMLTextAreaElement>)
    {
        this.setState({
            input: e.currentTarget.value,
            counter: 160 - e.currentTarget.value.length
        });
    }


    onInputFocus()
    {
        this.inputFocused = true;
    }


    onWindowDown(e: PointerEvent)
    {
        this.inputFocused = e.target == this.refInput.current;
    }


    send()
    {
        if (this.state.spam)
        {
            notifications.error(lang.shared["ui-components"].toastr["toastr-message"]["Anti spam delay time has not expired"]);
            return;
        }

        let message = this.state.input.trim();

        if (message.length == 0)
        {
            return;
        }

        const regex = /\/share_bet:(\d+)(.+)?/g;
        const match = regex.exec(message);
        if (match)
        {
            const bet = Controller.getBetCopy(match[1]);
            if (bet)
            {
                // TODO: unused characters: map avatars & currency
                // 0xE000          - share bet
                // 0xE001          - share bet limiter
                // 0xE002          - gif
                // 0xE003 - 0xE049 - avatar

                message = String.fromCharCode(0xE000) + [
                    bet.player_id,
                    bet.username,
                    bet.multiplier || "",
                    bet.win_amount || "",
                    bet.crashpoint || "",
                    bet.bet_amount,
                    bet.currency,
                    bet.game_round_id,
                    bet.timestamp,
                    match[2]
                ].join(String.fromCharCode(0xE001));
            }
            else
            {
                notifications.error(lang.shared["ui-components"].toastr["toastr-message"]["Something went wrong"]);

                this.refInput.current.value = "";
                this.setState({
                    input: "",
                    counter: 160,
                    spam: true,
                    window: null
                });

                return;
            }
        }


        const avatar = String.fromCharCode(0xE003 + Number(Controller.getAvatarForUser(Controller.player.id)) - 1);

        const compressed = avatar + message;

        const encoder = new TextEncoder();

        const prefixLength = 2;

        const messages: Array<string> = [""];
        let messageIdx = 0;

        for (let i = 0; i < compressed.length; i++)
        {
            if (encoder.encode(messages[messageIdx] + compressed[i]).length <= (160 - prefixLength))
            {
                messages[messageIdx] += compressed[i];
            }
            else
            {
                messageIdx++;
                messages[messageIdx] = compressed[i];
            }
        }

        messages.forEach((message, index, array) =>
        {
            Comm.sendChatMessage(
                (index + 1).toString() +
                array.length.toString() +
                message,
                this.onMessageSent, this
            );
        });

        this.refInput.current.value = "";
        this.setState({
            input: "",
            counter: 160,
            spam: true,
            window: null
        });

    }


    onMessageSent(data: any)
    {

    }


    clickNewMessages()
    {
        this.scrollToTop();
        this.setState({
            scroll: true,
            newMessage: false
        });
    }


    clickEmojies()
    {
        this.setState({
            window: "emoji",
            windowInput: ""
        });
    }


    clickGif()
    {
        this.setState({
            window: "gif",
            windowInput: ""
        });
    }


    render()
    {
        const lang = window.lang.game["chat-widget"];
        const lShared = window.lang.shared;

        return (
            <div
                id="chat"
                className="chat"
            >

                <div className="head">

                    <div className="players">
                        <div className="greenCircle"></div>
                        <div className="value">
                            {this.state.playersOnline}
                        </div>
                    </div>

                    <div
                        className="button"
                        onClick={app.closeChat.bind(app)}
                    >
                        ×
                    </div>

                </div>

                <div
                    className="content scroll-y"
                    ref={this.ref}
                    onScroll={this.onScroll.bind(this)}
                >
                    {this.renderMessages()}
                    {this.renderNewMessage()}
                </div>

                <div className="footer font_low">
                    <div className="inputArea">
                        <TextArea
                            minLength={1}
                            maxLength={160}
                            refinput={this.refInput}
                            disabled={this.state.spam}
                            placeholder={lShared.reply}
                            className="font_low"
                            onKeyDown={this.onKeyDown.bind(this)}
                            onInput={this.onInput.bind(this)}
                            onFocus={this.onInputFocus.bind(this)}
                        />
                        <div
                            className={"icon_enter " + (this.state.input.length > 0 ? "" : "disabled")}
                            onClick={this.send.bind(this)}
                        >

                        </div>
                    </div>

                    <div className="emojiArea">
                        <div
                            className="icon_emoji"
                            onClick={this.clickEmojies.bind(this)}
                        ></div>
                        <div
                            className="icon_gif"
                            onClick={this.clickGif.bind(this)}
                        ></div>
                        {/* <div className="icon_rain">
                            <div className="font_low">
                                {lang.rain}
                            </div>
                        </div> */}

                        <div className="counter">
                            {this.state.counter}
                        </div>
                    </div>

                    {this.renderSpam()}
                </div>

                {this.renderWindows()}

            </div>
        );
    }


    renderMessages()
    {
        const arr: Array<JSX.Element> = [];

        this.state.messages.forEach(data =>
        {
            switch (data.type)
            {
                case "player":
                    arr.push(this.renderPlayerMessage(data));
                    break;

                case "share":
                    arr.push(this.renderShareMessage(data));
                    break;

                case "bot":
                    arr.push(this.renderShareMessage(data, true));
                    break;

                case "gif":
                    arr.push(this.renderGifMessage(data));
                    break;
            }
        });

        return arr;
    }


    renderPlayerMessage(data: Comm.ResponseTypes.Chat)
    {
        return (
            <div
                className="message"
                key={"chat_message_" + data.id}
                onLoad={this.scrollToTop.bind(this)}
            >
                <img
                    className="avatar"
                    src={"gfx/avatars/av-" + Controller.getAvatarForUser(data.player_id.toString()) + ".png?version=" + version}
                />
                <div className="label">
                    <span
                        className="player"
                        onClick={this.addToChat.bind(this, "@" + data.sender + " ")}
                    >
                        {data.sender}
                    </span>
                    {data.message}
                </div>
                <div className="like">
                    <div className="count">
                        {data.likes > 0 ? data.likes : ""}
                    </div>
                    <div
                        className={"icon " + (data.liked ? "full" : "")}
                        onClick={this.clickLike.bind(this, data)}
                    ></div>
                </div>
            </div>
        );
    }




    renderShareMessage(data: Comm.ResponseTypes.Chat, bot: boolean = false)
    {
        const lang = window.lang.game["bets-widget"];
        // @ts-ignore
        const langChat = window.lang.game["chat-widget"]["chat-message"] as Record<string, string>;
        const lShared = window.lang.shared;
        return (
            <div
                className={"message share " + (bot ? "bot" : "player") + " " +
                    Common.parseMultiplierClassName(data.data.multiplier)}
                key={"chat_message_" + data.id}
                onLoad={this.scrollToTop.bind(this)}
            >
                <div className="header">
                    <img
                        className="avatar"
                        src={"gfx/avatars/av-" + Controller.getAvatarForUser(data.player_id.toString()) + ".png?version=" + version}
                    />
                    <div className="label">
                        <span
                            className="player"
                            onClick={this.addToChat.bind(this, "@" + data.sender + " ")}
                        >
                            {data.sender}
                        </span>
                        <span className="bot">
                            Bot
                        </span>
                        {langChat[data.message as string] || data.message}
                    </div>


                    <div className="like">
                        <div className="count">
                            {data.likes > 0 ? data.likes : ""}
                        </div>
                        <div
                            className={"icon " + (data.liked ? "full" : "")}
                            onClick={this.clickLike.bind(this, data)}
                        ></div>
                    </div>
                </div>

                <div className="content">
                    <div className="header">
                        <img
                            className="avatar"
                            src={"gfx/avatars/av-" + data.data.player_avatar + ".png?version=" + version}
                        />
                        <div className="label">
                            <span className="winner font_low">
                                {data.data.username}
                            </span>
                        </div>

                        <div
                            className="icon_fair"
                            onClick={this.checkFairness.bind(this, data.data.game_round_id.toString())}

                        ></div>
                    </div>

                    <div>

                        <div className="row">
                            <div className="item">
                                <div className="title font_low">
                                    {lShared["cashed_out"]}:
                                </div>
                                {Number(data.data.multiplier) ? (
                                    <div className={"value payout-unstyled " + Common.parseMultiplierClassName(data.data.multiplier)}>
                                        {Common.formatCurrency((Math.floor(Number(data.data.multiplier) * 100) * 0.01).toFixed(2)) + "x"}
                                    </div>
                                ) : (
                                    <div className="value">-</div>
                                )}
                                
                            </div>

                            <div className="item">
                                <div className="title font_low">
                                    {lShared.win}, {data.data.currency}:
                                </div>
                                <div className="value">
                                    {Common.renderCurrency(data.data.win_amount, data.data.currency, "-")}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="item">
                                <div className="title font_low">
                                    {lShared.round}:
                                </div>
                                <div className="value">
                                    {Number(data.data.crashpoint) ? Common.formatCurrency(data.data.crashpoint) + "x" : "-"}
                                </div>
                            </div>

                            <div className="item">
                                <div className="title font_low">
                                    {lShared.bet}, {data.data.currency}:
                                </div>
                                <div className="value">
                                    {Common.renderCurrency(data.data.bet_amount, data.data.currency)}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }


    renderGifMessage(data: Comm.ResponseTypes.Chat)
    {
        return (
            <div
                className="message gif"
                key={"chat_message_" + data.id}
                onLoad={this.scrollToTop.bind(this)}
            >
                <div className="message">
                    <img
                        className="avatar"
                        src={"gfx/avatars/av-" + Controller.getAvatarForUser(data.player_id.toString()) + ".png?version=" + version}
                    />
                    <div className="label">
                        <span
                            className="player"
                            onClick={this.addToChat.bind(this, "@" + data.sender + " ")}
                        >
                            {data.sender}
                        </span>
                    </div>
                    <div className="like">
                        <div className="count">
                            {data.likes > 0 ? data.likes : ""}
                        </div>
                        <div
                            className={"icon " + (data.liked ? "full" : "")}
                            onClick={this.clickLike.bind(this, data)}
                        ></div>
                    </div>
                </div>
                <div className="gif">
                    <img
                        src={data.message as string}
                    />
                </div>
            </div>
        );
    }


    renderNewMessage()
    {
        if (this.state.newMessage)
        {
            return (
                <div
                    className="newMessage font_low"
                    key="chat_new_message"
                    onClick={this.clickNewMessages.bind(this)}
                >
                    <div className="label">
                        {lang.game["chat-widget"]["New messages"]}
                    </div>
                    <div className="icon"></div>
                </div>
            );
        }
    }


    renderSpam()
    {
        if (this.state.spam)
        {
            return (
                <div
                    className={"spamFilter"}
                    key="chat_spam"
                >
                    <div className="slider">
                        <div
                            className="slide"
                            ref={this.refSpam}
                        >

                        </div>
                    </div>
                    <div className="label">
                        {lang.game["chat-widget"]["chat-input"]["please wait"]}
                    </div>
                </div>
            );
        }
    }


    // WINDOWS AREA


    onEmojiSelect(emoji: string)
    {
        this.addToChat(emoji);
    }


    onGifSelected(url: string)
    {
        const avatar = String.fromCharCode(0xE003 + Number(Controller.getAvatarForUser(Controller.player.id)) - 1);
        Comm.sendChatMessage(
            "11" + avatar + String.fromCharCode(0xE002) + url,
            this.onMessageSent, this
        );

        this.setState({
            window: null,
            spam: true
        });
    }


    closeWindows()
    {
        this.setState({
            window: null
        });
    }


    renderWindows()
    {
        switch (this.state.window)
        {
            case "emoji":
                return (
                    <Emojies
                        onSelect={this.onEmojiSelect.bind(this)}
                        close={this.closeWindows.bind(this)}
                    />
                )

            case "gif":
                return (
                    <Gifs
                        onSelect={this.onGifSelected.bind(this)}
                        close={this.closeWindows.bind(this)}
                    />
                );

            case "rain":
                return null;

            default:
                return null;
        }
    }


}


interface TextAreaAttributes extends React.TextareaHTMLAttributes<HTMLTextAreaElement>
{
    refinput: React.RefObject<HTMLTextAreaElement>;
}

class TextArea extends React.Component<TextAreaAttributes, {}>
{


    ref: React.RefObject<HTMLTextAreaElement>;
    propsState: TextAreaAttributes;


    constructor(props: TextAreaAttributes)
    {
        super(props);

        this.propsState = { ...this.props };
        this.ref = props.refinput;
    }


    shouldComponentUpdate(props: TextAreaAttributes)
    {
        if (props.disabled !== this.propsState.disabled)
        {
            this.propsState.disabled = props.disabled;
            this.ref.current.disabled = props.disabled;
        }
        return false;
    }


    render()
    {
        return (
            <textarea
                {...this.props}
                ref={this.ref}
            />
        )
    }

}


export namespace Chat
{

    export interface Props
    {

    }

    export interface State
    {
        input: string;
        playersOnline: number;
        spam: boolean;
        counter: number;
        messages: Array<Comm.ResponseTypes.Chat>;
        scroll: boolean;
        newMessage: boolean;

        window?: "emoji" | "gif" | "rain"
        windowInput: string;
    }

}